import type { MediaTransform } from "./media.js";
import type { CSSProperties } from "react";
import { hashStringBetween } from "shelving";
import { getMediaURL } from "./media.js";

/** Custom properties known in our CSS. */
export interface CustomCSSProperties extends CSSProperties {
	"--hue"?: number | undefined;
	"--image"?: `url(${string})` | undefined;
}

/** Get the style properties for an image and hue. */
export function getImageStyle(image: string | null = null, hue: number | null = null): CustomCSSProperties {
	return {
		"--hue": hue ?? undefined,
		"--image": image ? `url(${image})` : undefined,
	};
}

/** Get the style properties for an image and hue. */
export function getMediaImageStyle(path: string | null = null, hue: number | null = null, size?: MediaTransform): CustomCSSProperties {
	return getImageStyle(path ? getMediaURL(path, size) : null, hue);
}

/** Get a style where the hue is based on the current value of a string. */
export function getStringStyle(image: string | null = null, str: string): CustomCSSProperties {
	return getImageStyle(image, hashStringBetween(str, 0, 360));
}
